import { call, put, takeLatest, all } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";
import { FETCH_MISSING_IMAGES } from "store/imageMap/actionTypes";

// Redux States
import { 
  TOPIC_DETAILS_FETCH_REQUEST,
  TOPIC_DETAILS_FETCH_SUCCESS,
  TOPIC_DETAILS_FETCH_FAILURE,
} from "./actionTypes";

function* fetchTopicDetailsSaga(action) {
  console.log('running [fetchTopicDetailsSaga]', action);
  const { topicId } = action;

  try {

    const [topicRes, questionSetRes] = yield all([
      call(axiosInstance.get, `/knovia/myInfo/stores/${topicId}/getStoreTopicInfo`),
      call(axiosInstance.get, `/knovia/myInfo/stores/${topicId}/getQuestionSetsInStoreTopic`)
    ]);

    const sortedQuestionSets = [...questionSetRes.data].sort((a, b) => a.order - b.order);
    const questionSetIds = sortedQuestionSets.map(qs => qs._id);

    yield put({
      type: 'TOPIC_DETAILS_FETCH_SUCCESS',
      topicId,
      payload: {
        topicInfo: topicRes.data,
        questionSetIds
      }
    });

    yield put({
      type: 'QUESTION_SET_FETCH_SUCCESS',
      payload: sortedQuestionSets
    });

    const questionSetsImageFilenames = sortedQuestionSets.map(q => q.image).filter(Boolean);
    const topic = topicRes.data;

    // Collect all images to fetch
    const allFilenames = [
      topic.image,
      topic.backgroundImage,
      questionSetsImageFilenames
    ].filter(Boolean);

    // Trigger shared image loader
    yield put({ type: FETCH_MISSING_IMAGES, payload: { filenames: allFilenames, size: 'original' } });
  } catch (err) {
    console.error('[fetchTopicDetailsSaga] Error:', err);
    yield put({
      type: 'TOPIC_DETAILS_FETCH_FAILURE',
      error: err.message || 'Fetch failed'
    });
  }
}

function* topicDetailsSaga() {
  yield takeLatest(TOPIC_DETAILS_FETCH_REQUEST, fetchTopicDetailsSaga);
}

export default topicDetailsSaga;


